import React from 'react';
import pt from 'prop-types';

import { classNames } from 'utils';

import Icon from 'components/icon';
import DropdownDialog from 'components/dropdown-menu/dropdown-dialog';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from 'components/dropdown-menu';

export default class DropdownButton extends React.PureComponent {
  static propTypes = {
    items: pt.array,
    columns: pt.array,
    dialog: pt.object,
    onChangeOpen: pt.func,
    onClick: pt.func,
    button: pt.bool,
    buttonSize: pt.string,
    props: pt.object,
    modal: pt.bool,
    arrow: pt.bool,
    open: pt.bool,
    side: pt.string,
    sideOffset: pt.number,
    align: pt.string,
    alignOffset: pt.number,
    contentWidth: pt.string,
    keepOpen: pt.bool,
    disabled: pt.bool,
    className: pt.string,
    children: pt.node,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.open &&
      prevProps.open !== this.props.open &&
      !this.props.open
    ) {
      this.setState({ open: false });
    }
  }

  onClickItem = () => {
    return !this.props.keepOpen && this.setState({ open: false });
  };

  renderItem = (item, index) => {
    if (item?.type === 'li') {
      return item;
    }

    if (item?.type === 'hr' || item?.props?.children?.type === 'hr') {
      return <DropdownMenuSeparator key={index} />;
    } else if (item?.type === 'label') {
      return <DropdownMenuLabel key={index} {...item.props} />;
    }

    const renderedItem = typeof item === 'function' ? item(this) : item;

    return (
      renderedItem && (
        <DropdownMenuItem key={index} asChild onClick={this.onClickItem}>
          <div>{renderedItem}</div>
        </DropdownMenuItem>
      )
    );
  };

  renderDialog = (dialogProps) => {
    return (
      <DropdownMenuItem
        asChild
        onClick={this.onClickItem}
        className="dropdown-menu-item-dialog"
      >
        <DropdownDialog {...dialogProps} />
      </DropdownMenuItem>
    );
  };

  renderTrigger() {
    const {
      button = true,
      children,
      props,
      className,
      arrow = true,
    } = this.props;

    if (button) {
      return (
        <>
          {children}
          {!!arrow && <Icon fa="chevron-down" />}
        </>
      );
    }

    return (
      <span className={classNames('button-dropdown', className)}>
        <span className="button-dropdown-button">
          <span {...props}>{children}</span>
        </span>
      </span>
    );
  }

  onDropdownMenuChange = (open) => {
    const { onChangeOpen } = this.props;

    if (onChangeOpen) {
      onChangeOpen(open);
    }

    this.setState({ open });
  };

  render() {
    const {
      items = [],
      columns = [],
      button = true,
      buttonSize = 'sm',
      modal = false,
      side = 'bottom',
      sideOffset = 12,
      align = 'end',
      alignOffset = 12,
      contentWidth = '100%',
      dialog = null,
      disabled = false,
      className,
      onClick,
    } = this.props;
    const { open } = this.state;

    return (
      <DropdownMenu
        disabled={disabled}
        rootRest={{
          modal: modal,
          open: open,
          onOpenChange: this.onDropdownMenuChange,
        }}
        contentRest={{
          side: side,
          sideOffset: sideOffset,
          align,
          alignOffset: alignOffset,
          avoidCollisions: true,
          style: { minWidth: contentWidth },
        }}
        contentClassName={
          dialog
            ? 'dropdown-menu-content dropdown-menu-content-dialog'
            : columns.length > 0
            ? 'dropdown-menu-content dropdown-menu-content-grid'
            : null
        }
        triggerChildren={this.renderTrigger()}
        triggerClassName={classNames(
          button
            ? `button button-${buttonSize || 'sm'} button-secondary`
            : 'button-dropdown',
          className,
        )}
        triggerRest={{
          onClick,
        }}
      >
        {dialog ? (
          this.renderDialog(dialog)
        ) : columns.length > 0 ? (
          <>
            {columns.map(
              (col, index) =>
                col && (
                  <div key={index} className="dropdown-menu-item-grid-col">
                    {col.map(
                      (item, index) => item && this.renderItem(item, index),
                    )}
                  </div>
                ),
            )}
          </>
        ) : (
          <>
            {items.map((item, index) => item && this.renderItem(item, index))}
          </>
        )}
      </DropdownMenu>
    );
  }
}
